import { render, staticRenderFns } from "./customer-return-data.vue?vue&type=template&id=043c1ce6"
import script from "./customer-return-data.vue?vue&type=script&lang=js"
export * from "./customer-return-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports